<template>
  <v-app id="app">
    <AppBar />

    <v-content id="container">
      <Views />
    </v-content>

    <Footer />
  </v-app>
</template>

<script>
import AppBar from "./components/core/AppBar";
import Footer from "./components/core/Footer";
import Views from "./components/core/Views";
export default {
  name: "App",
  components: {
    AppBar,
    Views,
    Footer,
  },
  computed: {
    error: {
      get() {
        return this.$store.getters["error/error"];
      },
      set(value) {
        this.$store.dispatch("error/setError", value);
      },
    },
    loading: {
      get() {
        return this.$store.getters["loading/loading"];
      },
      set(value) {
        this.$store.dispatch("loading/setLoading", value);
      },
    },
  },
};
</script>
